import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[shelf-append]',
})
export class ShelfAppendDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}




// WEBPACK FOOTER //
// ./src/app/shelf/directives/shelfAppend.directive.ts